<template>
  <div class="DayLook">
    <!-- 上面正常显示部分 -->
    <div class="dayLook_top">
      <div class="title_box">
        <div class="ico_tuwen">
          <img
            src="https://fview.5kjs.com/activity/21sign/image/pc/details.png"
            alt=""
          />
        </div>
        <div
          class="day"
          v-if="
            status.sign_type == '作业打卡' ||
            status.detail.sign_type == '作业打卡'
          "
        >
          第 {{ myitem.day }} 课
        </div>
        <div class="day" v-else>
          <div>DAY {{ myitem.day }}</div>
           <div class="endTime">{{ myitem.endOfDate }}</div>
          </div>
        <div class="info_class">（ {{ myclass }} ）</div>
        <div class="title">
          {{ myitem.lesson_name }}
          <el-tooltip effect="dark" placement="top-start">
            <div slot="content">
              <p style="padding: 3px 0">{{ myitem.sign_content }}</p>
            </div>
            <i
              class="iconfont icon-wenhao"
              :class="[myitem.sign_status == '1' ? '' : '']"
              v-if="is_login == true && is_apply"
            ></i>
          </el-tooltip>
          <div
            class="MYcarStatus"
            :class="[myitem.sign_status == '1' ? 'cardOk' : '']"
            v-if="is_apply"
          >
            <span v-if="myitem.sign_status != '1'" class="duigou">未打卡</span>
            <span v-else class="duigou">已打卡</span>
          </div>
          <div class="learn_rate" v-if="myitem.learn_rate != 0">
            <span>已学：</span>{{ myitem.learn_rate }} %
          </div>
        </div>
      </div>
      <div class="btn" v-if="is_apply">
        <!-- 如果学习类型为视频则显示开始学习按钮 -->
        <button
          @click="open()"
          :class="[
            myitem.lesson_type == 'paper' ||
            myitem.lesson_type == 'knowledge' ||
            myitem.lesson_type == 'graphic_library'
              ? 'btn_text'
              : 'btn_video',
          ]"
          v-if="myitem.leve == null"
        >
          {{ myclass | classType }}
        </button>
        <!-- 如果学习类型为做题则显示下拉按钮 -->
        <div v-else class="section_down" @click="down()">
          <span>{{ downFlag == false ? "展开" : "收起" }}</span>
          <i
            class="iconfont icon-jiantoudown"
            :class="[downFlag == false ? 'icoDwon' : 'icoUp']"
          ></i>
        </div>
      </div>
    </div>

    <!-- 下侧章节下拉框 -->
    <transition>
      <div class="children_box" v-if="downFlag">
        <!-- 循环元素 -->
        <div
          class="children"
          v-for="(item, index) in myitem.leve"
          :key="item.id"
        >
          <div class="childern_title">
            <span class="childern_title_num">{{ index }}</span>
            <span class="childern_title_text">{{ item.title }}</span>
          </div>
          <div class="childern_btn_box" @click="sectionOpen(item.id)">
            <button class="childern_btn">开始刷题</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DayLook",
  props: {
    infoClass: {
      type: Number,
      defulat: 0,
    },
    myitem: {
      type: Object,
      default: () => {
        return {
          day: "1",
          lesson_name: "词义辨析专项训练",
          lesson_type: "paper",
          pattern_id: 3132,
          pattern_url: "",
        };
      },
    },
    // 用户是否报名课程
    is_apply: {
      type: Boolean,
      defulat: false,
    },
    // 用户是否登录
    is_login: {},
    // detail信息
    status: {
      type: Object,
      defulat: "signing",
    },
  },
  data() {
    return {
      camp_id: null,
      token: localStorage.getItem("token"),
      agency_id: localStorage.getItem("agency_id"),
      // 章节下拉框显示控制器
      downFlag: false,
    };
  },
  methods: {
    // 点击确定的跳转按钮
    open() {
      // let url = window.location.origin + `${this.myitem.pattern_url}`;
      if (this.status.status == "signing" || this.is_apply) {
        if (this.is_apply) {
          if (this.myitem.is_open == false) {
            this.$alert("课程还未开放", "提示", {
              confirmButtonText: "确定",
            });
            return;
          } else {
            if (this.myitem.lesson_type == "paper") {
              this.$router.push({
                path: `/text/${this.myitem.lesson_id}`,
                query: { camp: this.camp_id },
              });
            } else if (this.myitem.lesson_type == "knowledge") {
              this.$router.push({
                path: `/text/${this.myitem.lesson_id}`,
                query: {
                  knowledge_id: this.myitem.pattern_id,
                  camp: this.camp_id,
                },
              });
            } else if (this.myitem.lesson_type == "graphic_library") {
              this.$router.push({
                path: `/text/${this.myitem.lesson_id}`,
                query: { camp: this.camp_id, tuwen: true },
              });
              // this.$router.push({
              //   path: `/Detail/imageText/${this.camp_id}`,
              //   query: {
              //     lesson_id:this.myitem.lesson_id,
              //     camp: this.camp_id,
              //     pattern_id:this.myitem.pattern_id
              //   },
              // });
            } else {
              this.$router.push({
                path: `/video/${this.myitem.lesson_id}`,
                query: { camp: this.camp_id },
              });
            }
          }
        } else {
          let url = window.location.origin + "/buy/camp/";
          this.$axios
            .get("/canBuy", {
              params: {
                token: this.token,
                agency_id: this.agency_id,
                camp_id: this.camp_id,
              },
            })
            .then((doc) => {
              if (doc == null) {
                window.location.href = url + this.camp_id;
              } else if (doc.data.code == 201) {
                this.$alert(doc.data.message, "提示", {
                  confirmButtonText: "确定",
                });
                location.reload();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        this.$alert("课程已停止报名", "提示", {
          confirmButtonText: "确定",
        });
      }
      // .href = url;

      // 课程开放条件判断测试完之后记得放开
      // if (this.myitem.is_open) {
      // if (this.myitem.lesson_type == "paper") {
      //   this.$router.push({ path: "/text", query: { class: this.myitem.pattern_url } });
      // } else {
      //   this.$router.push({ path: "/video", query: { class: this.this.myitem.pattern_url  } });
      // }
      // } else {
      //   this.$alert("同学不要心急噢~课程还没有开放呢~~~~", "提示", {
      //     confirmButtonText: "确定",
      //   });
      // }
    },
    // 章节下拉框事件
    down() {
      this.downFlag = !this.downFlag;
    },
    // 章节部分的点击跳转部分
    sectionOpen(knowledge_id) {
      if (this.myitem.is_open == false) {
        this.$alert("课程还未开放", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else {
        this.$router.push({
          path: `/text/${this.myitem.lesson_id}`,
          query: { knowledge_id: knowledge_id, camp: this.camp_id },
        });
      }
    },
  },
  mounted() {
    this.camp_id = this.$route.params.id;
    setTimeout(() => {
      this.token = localStorage.getItem("token");
      this.agency_id = localStorage.getItem("agency_id");
    }, 300);
  },
  computed: {
    myclass() {
      var className = "";
      switch (this.myitem.lesson_type) {
        case "paper":
          className = "题目";
          break;
        case "classes":
          className = "班级";
          break;
        case "package":
          className = "套餐";
          break;
        case "live":
          className = "直播";
          break;
        case "knowledge":
          className = "章节";
          break;
        case "graphic_library":
          className = "图文";
          break;
      }
      return className;
    },
  },
  filters: {
    classType: function (value) {
      if (value == "题目") {
        return "开始刷题";
      } else if (value == "班级") {
        return "开始学习";
      } else if (value == "直播") {
        return "观看直播";
      } else if (value == "章节") {
        return "开始刷题";
      }else if(value == "图文"){
        return "查看图文"
      }
    },
  },
};
</script>

<style lang="less" scoped>
.iconfont::before {
  font-size: 0.85rem;
}
div {
  font-size: 1rem;
}

.dayLook_top {
  padding: 0.3125rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 3.375rem;
  background: #f5f7fa;
}

.DayLook {
  margin-bottom: 1.5625rem;
  border-radius: 0.125rem;
  // 左侧文字部分
  .title_box {
    padding: 0.3125rem 0;
    margin-left: 1.1875rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .ico_tuwen {
      width: 1.3125rem;
      height: 1.3125rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .day {
      margin: 0 1.25rem 0 0.5rem;
      color: #686868;
      font-size: 1rem;
      font-weight: Bold;
      .endTime{
        font-size: .7rem;
        font-weight: 400;
        color: #999;
      }
    }
    .info_class {
      margin-right: 0.9375rem;
      font-size: 1rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #686868;
    }
    .title {
      flex: 1;
      font-size: 1rem;
      font-family: " Microsoft YaHei";
      font-weight: 400;
      color: #686868;
    }
    .carOk {
      color: #ff8673;
    }
    .MYcarStatus {
      // line-height: 0.155rem;
      display: inline-block;
      flex-shrink: 0;
      margin-left: 0.7125rem;
      padding: 0.1875rem 0.25rem;
      border-radius: 0.1875rem;
      font-size: 0.5625rem;
      color: #fff;
      background-color: #d1d5d7;
      .icon-duigou {
        color: #d1d5d7;
      }
    }

    .learn_rate {
      display: inline-block;
      flex-shrink: 0;
      margin-left: 0.7125rem;
      padding: 0.1875rem 0.25rem;
      border-radius: 0.1875rem;
      font-size: 0.5625rem;
      color: #fff;
      background: #ff9e1c;
    }

    .cardOk {
      color: #fff;
      background-color: #24bf9d;
      .icon-duigou {
        color: #24bf9d;
      }
    }
  }
  // 按钮部分
  .btn {
    flex-shrink: 0;
    margin-right: 0.6875rem;
    width: 5.5rem;
    height: 1.9375rem;
    // 做题按钮
    .btn_text {
      width: 100%;
      height: 100%;
      font-size: 0.875rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #ffffff;
      background: #ff7d3a;
      border: 0.0625rem solid #e8e8e8;
      border-radius: 0.1875rem;
      cursor: pointer;
    }
    .btn_video {
      width: 100%;
      height: 100%;
      font-size: 0.875rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #ffffff;
      background: #ffba61;
      border: 0.0625rem solid #e8e8e8;
      border-radius: 0.1875rem;
      cursor: pointer;
    }
    .btn_video:hover,
    .btn_text:hover {
      text-decoration: underline;
    }

    // 章节学习展开按钮
    .section_down {
      cursor: pointer;
      margin-right: 0.625rem;
      text-align: center;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #686868;
      span {
        margin-right: 0.5rem;
      }
      .icoUp {
        transform: rotate(180deg);
      }
    }
  }
}

.children_box {
  .children {
    height: 3.9375rem;
    background-color: #fff;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .childern_title {
      margin-left: 1.1875rem;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #686868;
      .childern_title_text {
        margin-left: 0.375rem;
      }
    }
    .childern_btn_box {
      flex-shrink: 0;
      margin-right: 0.6875rem;
      width: 5.5rem;
      height: 1.9375rem;
      .childern_btn {
        width: 100%;
        height: 100%;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #ffffff;
        background: #ff7d3a;
        border: 0.0625rem solid #e8e8e8;
        border-radius: 0.1875rem;
        cursor: pointer;
      }
    }
  }
  .children:last-child {
    border-bottom: none;
    margin-bottom: -1.675rem;
  }
}
</style>